module.exports = __webpack_public_path__ + "img/widget.180f8885.png";